/* src/app/webhook-creator/webhook-creator/webhook-edit/webhook-edit-toolbox/webhook-edit-toolbox.component.scss */
.wh-toolbox-header-title {
  display: block;
  font-size: 1.2em;
  line-height: 1em;
  font-weight: 700;
  margin-left: 15px;
}
.wh-toolbox-toggle-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  width: 16px;
  font-size: 16px;
  height: 16px;
  margin: -8px 0 0;
}
.wh-toolbox-scrollable {
  position: relative;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}
.wh-toolbox-itens {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.wh-toolbox-item-text {
  position: relative;
  display: block;
  padding: 10px 10px 10px 30px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  height: 100%;
}
.wh-toolbox-toggle-icon-drag {
  position: absolute;
  left: 2px;
  top: 11px;
  cursor: move;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.wh-toolbox-item-icon {
  position: absolute;
  top: 50%;
  left: 5px;
  margin-top: -10px;
  font-size: 20px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.wh-toolbox-body {
  display: flex;
  height: 100%;
  flex-direction: column;
}
.wh-toolbox-closed {
  animation: fadeUp 1.5s ease-in-out forwards;
}
.wh-toolbox-opened {
  animation: fadeDown 0.5s ease-out forwards;
}
@keyframes fadeUp {
  0% {
    opacity: 1;
    height: 500px;
  }
  100% {
    height: 0;
    opacity: 0;
  }
}
@keyframes fadeDown {
  0% {
    opacity: 0;
    transform: translateY(0);
  }
  100% {
    opacity: 1;
  }
}
.external-item,
.external-item-placeholder,
.external-item-preview {
  padding: 4px;
  min-height: 24px;
  background-color: var(--node-background-color);
  border: 1px solid var(--node-border-color);
  border-radius: 4px;
  overflow: hidden;
  text-align: center;
  -webkit-user-select: none;
  user-select: none;
}
.workflow-tool-item {
  cursor: pointer;
  border: 0.2px solid var(--node-border-color);
  background: var(--node-background-color);
  border-radius: var(--node-border-radius);
  box-shadow: var(--tem-shadow, 0 2px 2px rgba(0, 0, 0, 0.15));
  color: var(--node-color);
  min-height: 40px;
  min-width: 40px;
  max-width: 40px;
  max-height: 40px;
  text-align: center;
  padding-top: 8px;
}
.workflow-tool-item-text {
  display: block;
  font-size: 0.5em;
  line-height: 2em;
  font-weight: 500;
}
.workflow-tool-wrapper {
  padding: 20px;
}
/*# sourceMappingURL=webhook-edit-toolbox.component.css.map */
